import { Card, CardContent } from "@/components/ui/card";

export function ApplicationCardSkeleton() {
  return (
    <Card>
      <CardContent className="py-5 pl-6 pr-5">
        {/* Header row skeleton. */}
        <div className="flex items-start justify-between gap-4 mb-4">
          <div className="flex items-center gap-3 flex-1">
            <div className="h-8 w-8 rounded-md bg-muted animate-pulse" />
            <div className="h-6 w-48 bg-muted rounded animate-pulse" />
          </div>
          <div className="flex items-center gap-3">
            <div className="h-7 w-20 bg-muted rounded-full animate-pulse" />
            <div className="h-5 w-16 bg-muted rounded animate-pulse" />
            <div className="h-8 w-8 bg-muted rounded animate-pulse" />
          </div>
        </div>

        {/* Replica visualization skeleton. */}
        <div className="mb-4 space-y-2">
          <div className="h-4 w-40 bg-muted rounded animate-pulse" />
          <div className="flex gap-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="w-14 h-12 bg-muted rounded animate-pulse"
              />
            ))}
          </div>
        </div>

        {/* Metrics skeleton. */}
        <div className="mb-4">
          <div className="h-4 w-64 bg-muted rounded animate-pulse" />
        </div>

        {/* Metadata skeleton. */}
        <div className="h-4 w-56 bg-muted rounded animate-pulse" />
      </CardContent>
    </Card>
  );
}
